// total_new_payment_req_count

import axios from "../../axios";
import { useMutation, useQuery } from "react-query"
import { route } from './routes';



export function useSellerPaymentReqestCount(){
  return useQuery([route.PAYMENT_REQUEST_COUNT], async() => {
    const { data } = await axios.get(route.PAYMENT_REQUEST_COUNT);
    return data;
  })
}
